import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { hideAppDialog } from "../redux/slices/appdialogslice";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";

export const AppDialog = (props) => {
  const dispatch = useDispatch();
  const appDialog = useSelector((state) => state.appDialog);
  const currentTheme = useSelector((state) => state.currentTheme);
  const appearance = useSelector((state) => state.appearance);

  if (!appDialog.isVisible) return null;

  return (
    <React.Fragment>
      <Dialog
        className={appDialog.className ? appDialog.className : ""}
        title={appDialog.title ? appDialog.title : ""}
        closeIcon={appDialog.closable}
        onClose={
          appDialog.closeHandler
            ? appDialog.closeHandler
            : () => dispatch(hideAppDialog())
        }
        
      >
        {appDialog.content}
        {appDialog.actions && (
          <DialogActionsBar>
            {appDialog?.actions?.yesButton && (
              <button
                className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                onClick={
                  appDialog.actions.yesButton.handler
                    ? appDialog.actions.yesButton.handler
                    : () => dispatch(hideAppDialog())
                }
              >
                {appDialog.actions.yesButton.title}
              </button>
            )}
            {appDialog?.actions?.noButton && (
              <button
                className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                onClick={
                  appDialog.actions.noButton.handler
                    ? appDialog.actions.noButton.handler
                    : () => dispatch(hideAppDialog())
                }
              >
                {appDialog.actions.noButton.title}
              </button>
            )}
          </DialogActionsBar>
        )}
      </Dialog>
      <style>
        {`
            .k-dialog-wrapper{
                direction:${
                          appearance.isRightToLeft ? "rtl" : "ltr"
                        }  
            }
            .k-window-title.k-dialog-title{
                padding: 4px 0;
            }     
        `}
      </style>
    </React.Fragment>
  );
};
